
export const isNullOrUndefindedAndEmpty = (objeto) => {
    return (typeof objeto === undefined || objeto === null || objeto === '')
}